import script from "./EditExam.vue?vue&type=script&setup=true&lang=js"
export * from "./EditExam.vue?vue&type=script&setup=true&lang=js"

import "./EditExam.vue?vue&type=style&index=0&id=206f5c8e&lang=css"

const __exports__ = script;

export default __exports__